import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '@enviroment/environment';

@Pipe({
  name: 'regionWord',
  standalone: true
})
export class RegionWordPipe implements PipeTransform {

  transform(value: string | null | undefined): string {
    if (!value) return '';

    // Solo aplicar reemplazo para España
    if (environment.region !== 'ES') {
      return value;
    }

    return this.applyRegionReplacements(value);
  }

  private applyRegionReplacements(text: string): string {
    return text
      // =========================
      // COLONIA -> PROVINCIA
      // =========================

      // MAYUSCULAS
      .replace(/\bCOLONIAS\b/g, 'PROVINCIAS')
      .replace(/\bCOLONIA\b/g, 'PROVINCIA')

      // Capitalizado
      .replace(/\bColonias\b/g, 'Provincias')
      .replace(/\bColonia\b/g, 'Provincia')

      // minusculas
      .replace(/\bcolonias\b/g, 'provincias')
      .replace(/\bcolonia\b/g, 'provincia')

      // =========================
      // SUCURSAL -> CONSULTORIO
      // =========================

      // MAYUSCULAS
      .replace(/\bSUCURSALES\b/g, 'CONSULTORIOS')
      .replace(/\bSUCURSAL\b/g, 'CONSULTORIO')

      // Capitalizado
      .replace(/\bSucursales\b/g, 'Consultorios')
      .replace(/\bSucursal\b/g, 'Consultorio')

      // minusculas
      .replace(/\bsucursales\b/g, 'consultorios')
      .replace(/\bsucursal\b/g, 'consultorio');
  }
}
